var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.625C0.5 1.01562 0.96875 0.5 1.625 0.5H3.73438C4.76562 0.5 5.70312 1.10938 6.125 2H25.3906C26.6094 2 27.5 3.17188 27.1719 4.39062L25.25 11.5156C24.875 13.0156 23.5156 14 22.0156 14H8.46875L8.75 15.3594C8.84375 15.875 9.3125 16.25 9.82812 16.25H23.375C23.9844 16.25 24.5 16.7656 24.5 17.375C24.5 18.0312 23.9844 18.5 23.375 18.5H9.82812C8.23438 18.5 6.82812 17.375 6.54688 15.7812L4.10938 3.07812C4.0625 2.89062 3.92188 2.75 3.73438 2.75H1.625C0.96875 2.75 0.5 2.28125 0.5 1.625ZM6.5 22.25C6.5 21.4531 6.92188 20.75 7.625 20.3281C8.28125 19.9062 9.17188 19.9062 9.875 20.3281C10.5312 20.75 11 21.4531 11 22.25C11 23.0938 10.5312 23.7969 9.875 24.2188C9.17188 24.6406 8.28125 24.6406 7.625 24.2188C6.92188 23.7969 6.5 23.0938 6.5 22.25ZM22.25 20C23.0469 20 23.75 20.4688 24.1719 21.125C24.5938 21.8281 24.5938 22.7188 24.1719 23.375C23.75 24.0781 23.0469 24.5 22.25 24.5C21.4062 24.5 20.7031 24.0781 20.2812 23.375C19.8594 22.7188 19.8594 21.8281 20.2812 21.125C20.7031 20.4688 21.4062 20 22.25 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.01f1f96966422add6be636061166856d.svg";
export { ForwardRef as ReactComponent };